import type { Layout, Tab, Theme } from './types';

export const STORAGE_KEY = 'shiftagent-workspace-v1';

/**
 * Left nav rail sizing (expanded state). MIN keeps the grouped labels legible;
 * MAX stops the rail from eating the workspace. DEFAULT matches the original
 * fixed width so existing users see no jump on upgrade.
 */
export const SIDEBAR_MIN_WIDTH = 200;
export const SIDEBAR_MAX_WIDTH = 420;
export const SIDEBAR_DEFAULT_WIDTH = 248;

export interface PersistedState {
  layout: Layout;
  activeLeafId: string | null;
  theme: Theme;
  recentlyClosed: Tab[];
  sidebarCollapsed: boolean;
  /** User-chosen width of the left nav rail in px (expanded state only). */
  sidebarWidth: number;
}

export function loadState(): PersistedState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PersistedState>;
    if (!parsed.layout) return null;
    return {
      layout: parsed.layout,
      activeLeafId: parsed.activeLeafId ?? null,
      theme: parsed.theme ?? 'light',
      recentlyClosed: parsed.recentlyClosed ?? [],
      sidebarCollapsed: parsed.sidebarCollapsed ?? false,
      sidebarWidth: parsed.sidebarWidth ?? SIDEBAR_DEFAULT_WIDTH,
    };
  } catch {
    return null;
  }
}

export function saveState(state: PersistedState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Quota exceeded or storage unavailable — non-fatal.
  }
}
